import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.04492 18.5913H20.9553",
      stroke: "#303333"
    }, null, -1),
    _createElementVNode("path", {
      d: "M20.8008 18.0981L20.8008 21.9576",
      stroke: "#303333"
    }, null, -1),
    _createElementVNode("path", {
      d: "M3.30469 18.0981L3.30469 21.9576",
      stroke: "#303333"
    }, null, -1),
    _createElementVNode("rect", {
      x: "3.25",
      y: "4.02051",
      width: "17.5",
      height: "10.7458",
      stroke: "#303333"
    }, null, -1)
  ])))
}
export default { render: render }